module.exports = __webpack_public_path__ + "static/media/sharing.787bc482.png";